import type { RuleTemplate, StringConst } from '../../../../../interfaces/Interfaces';
import { ACTION_TYPE, CASE_ATTRIBUTE } from '../../../../../interfaces/enums';
import { ValidationResult } from '../../../../DunningSelectionPage/DunningSelection/input/Validators';

export function validateConditionIfDebtCollectionAction(ruleEdit: RuleTemplate): ValidationResult | null {
  if (ruleEdit.actions.filter(action => action['@type'] === ACTION_TYPE.DEBT_COLLECTION).length > 0) {
    const relevantConditions = ruleEdit.caseConditions.filter(
      condition => condition.attrib === CASE_ATTRIBUTE.PROCESS_DEBT_COLLECTION,
    );
    const valid =
      relevantConditions.length > 0 &&
      relevantConditions.some(condition => (condition.argument as StringConst).val === 'false');

    if (relevantConditions.length === 0) {
      return {
        error: true,
        message: 'error.rule-editor.missing-debt-collection-handler-cond',
      };
    }

    if (!valid) {
      return {
        error: true,
        message: 'error.rule-editor.existing-debt-collection-handler-cond',
      };
    }
  }
  return null;
}
